export default "__VITE_ASSET__HzMCbrjM__"